import RiskChartWidgetView, { type RiskChartWidgetState } from './RiskChartWidgetView.tsx';
import RiskChartWidgetSettings from './RiskChartWidgetSettings.tsx';
import type { CustomWidgetDescription } from 'components/management/customDashboard/CustomWidgetDescription.types.ts';
import { PORTFOLIO_VOLATILITY_METRIC } from 'components/metrics/PortfolioMetricsData.ts';
import { range7Days } from 'components/predefinedDateRanges.ts';
import { StackedLineChart } from '@mui/icons-material';

export const riskChartWidget: CustomWidgetDescription = {
  type: 'riskChart',
  name: 'Risk',
  description: 'Displays a chart of risk metrics over time.',
  icon: () => <StackedLineChart />,
  viewComponent: RiskChartWidgetView,
  settingsComponent: RiskChartWidgetSettings,
  initialState: {
    title: 'Volatility',
    metricInput: {
      metric: PORTFOLIO_VOLATILITY_METRIC,
      params: {
        Window: '30',
        'Window type': ['rolling'],
        'Metric type': ['realized'],
        Annualized: ['not_annualized'],
      },
    },
    predefinedDateRange: range7Days.label,
    showContributionIfAvailable: true,
    warmUpPeriod: '30',
  } satisfies RiskChartWidgetState,
  initialW: 6,
  initialH: 4,
};
